import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../../Atoms/Typography'
import Button from '../../../Atoms/Button'
import Checkbox from '../../../Atoms/Checkbox'

import theme from '../../../../styles/theme'

const Container = styled(View)`
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.lightgrey};
`

const Row = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  margin-top: ${3 * theme.gutterUnit}px;
`

const TeamButton = styled(Button)`
  border-radius: 20px;
  border-width: ${props => props.active ? '0' : '2px'};
  background-color: ${props => props.active ? theme.colours.primary : theme.colours.white};
  height: 40px;
  padding: ${theme.gutterUnit}px;
`
const teamArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

export default class TeamSelection extends PureComponent {
  render () {
    const { onTeamSelect, selectedTeam, isMaster, onMasterSelect } = this.props
    return (
      <Container>
        <Text bold>SELECT TEAM</Text>
        <Row>
          {teamArray.map(team => {
            let active = false
            if (team === selectedTeam) {
              active = true
            }
            return (
              <TeamButton
                key={team} active={active} onPress={() => {
                  onTeamSelect(team)
                }}
              >
                <Text size='s' white={active}>Team {team}</Text>
              </TeamButton>
            )
          })}
        </Row>
        <Row>
          <Checkbox
            onClick={onMasterSelect}
            isChecked={isMaster}
            text='Can submit master decisions'
          />
        </Row>
      </Container>
    )
  }
}
